<template>
  <div id="edit-user">
    <h1>Edit User</h1>
    <form @submit.prevent="editUser">
      <div v-if="isError" class="error">Error with form<br /></div>
      <label>Full Name</label><br />
      <input
        ref="fullNameField"
        v-model.trim="user.full_name"
        type="text"
        required
      /><br />
      <label>First Name</label><br />
      <input
        ref="firstNameField"
        v-model.trim="user.first_name"
        type="text"
        required
      /><br />
      <label>Email</label><br />
      <input
        ref="emailField"
        v-model.trim="user.email"
        type="text"
        required
      /><br />
      <div v-if="isEmailError" class="error">{{ errorEmailMessage }}<br /></div>
      <button class="button button-300" type="submit">Update</button>
    </form>
  </div>
</template>

<script>
export default {
  name: "UserEdit",
  data() {
    return {
      isError: false,
      isEmailError: false,
      errorEmailMessage: ""
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    // userEditAPIError () {
    //   return this.$store.getters.userEditAPIError;
    // },
    apiError() {
      return this.$store.getters.apiError;
    },
    apiErrorMessage() {
      return this.$store.getters.apiErrorMessage;
    }
  },
  created() {
    this.$store.dispatch("getUser");
    // this.$store.commit('setUserEditAPIError', false);
    this.$store.dispatch("resetAllAPIErrorAndMessages");
  },
  methods: {
    editUser: function() {
      // this.$store.commit('setUserEditAPIError', false);
      this.$store.dispatch("resetAllAPIErrorAndMessages");
      this.isError = false;
      this.isEmailError = false;
      let reEmailFormat = /^[^@|^\s]+@\S+\.\S+/;
      let resultEmailFormat = reEmailFormat.test(this.user.email);
      if (!resultEmailFormat) {
        this.isError = true;
        this.isEmailError = true;
        this.errorEmailMessage = "Invalid email entered";
      }
      if (!this.isError) {
        this.$store.dispatch("editUser", this.user);
      }
    }
  }
};
</script>

<style scoped>
#edit-user {
  text-align: left;
  margin-left: 20px;
}
#edit-user div {
  padding: 15px;
}
</style>
